import { ExternalLink, TARGET_BLANK } from "@sundae/ui-toolkit";
import { ILinkProps } from "@sundae/ui-toolkit/dist/types/components/atoms/Link/Link";
import { FC, PropsWithChildren } from "react";
import { useCardanoExplorer } from "../../hooks/useCardanoExplorer";
import { truncateString } from "../../utils/string-format";

export interface ICardanoExplorerProps extends ILinkProps {
  label?: string;
  // for now, tracking tx and tokens is enough. we might add more (e.g. blocks, epochs etc. on a later stage)
  hash: string;
  type: string;
  truncateFrom?: number;
  truncateUntil?: number;
}

const CardanoExplorer: FC<PropsWithChildren<ICardanoExplorerProps>> = ({
  arrow = "top-right",
  children,
  hash,
  type,
  variant = "primary",
  truncateFrom = 10,
  truncateUntil = 8,
  ...linkProps
}) => {
  const explorerLink = useCardanoExplorer({ type, hash });

  return (
    <ExternalLink
      arrow={arrow}
      className="cursor-pointer"
      href={explorerLink}
      hoverable
      variant={variant}
      {...TARGET_BLANK}
      {...linkProps}
    >
      {children ?? truncateString(hash, truncateFrom, truncateUntil)}
    </ExternalLink>
  );
};

export default CardanoExplorer;
